import React from 'react';
import {
    getIsActiveLink,
    mapLinkToListItem,
} from '@pluto/sidebar-list-item';
import Search from '@material-ui/icons/Search';

import {baseRoutes} from '../../AppRouter/routes';

export const LINKS = [{
    route: baseRoutes.contentItemsSearch,
    icon: <Search />,
    title: 'Search',
}];

export default function AppSidebarCommonLinks({path}:any): any {
    const withPath = getIsActiveLink(path);
    
    return LINKS.map(mapLinkToListItem(withPath) as any);
}

